/**
 * Lite chat-input config used by the clarification create form and reply field. Uses the
 * redesign v2 composer (square shell, `+` attach menu, mic, send) at a narrow width, but
 * WITHOUT the footer instruction zone or context indicator — those belong to the Claudia
 * surfaces only. Voice input is enabled per call site via the `voiceInput` prop.
 *
 * Spread at the call site, e.g.:
 *   <MessageRichTextInput {...clarificationInputDefaults} placeholder="..." onSubmit={...} />
 */
export const clarificationInputDefaults = {
  toolbarPreset: "none",
  composerLayout: true,
  attachMenu: true,
  enterKeyBehavior: "enterToSendUnlessMultiline",
  features: {
    mentions: true,
    emojiReplacement: false,
    internalLinkResolution: false,
  },
} as const;
